import OSS from 'ali-oss';
import { nanoid } from 'nanoid';

const file = function (){}
/**
 * 选择文件
 * @param {Object | undefined} options 
 * @returns {Promise | undefined}
 */
file.cloose = function(options = {}){
    return new Promise(resolve=>{
        let dom = document.createElement('input'); 
        dom.type = 'file';
        dom.accept = options.accept || '';
        dom.multiple = options.multiple || false;
        dom.onchange = function(){
            let files = dom.files;
            if(options.multiple){
                files.length > 0 && resolve(files);
            }else{
                let file = files[0];
                file && resolve(file);
            }
        }
        let event = new MouseEvent('click');
        dom.dispatchEvent(event);
    })
}
/**
 * oss上传
 * @param {Object} options 
 * @returns {Promise}
 */
file.ossUpload = function(options){
    if(!options || !options.file || !options.uploadOptions) return Promise.reject();
    let {
        file,
        type,
        uploadOptions,
        headers = {}
    } = options;
    headers = {
        'Cache-Control': 'public',
        'Content-Disposition': encodeURIComponent(file.name),
        ...headers
    }
    return new Promise((resolve, reject)=>{
        const client = new OSS({
            region: uploadOptions.Region,
            accessKeyId: uploadOptions.AccessKeyId,
            accessKeySecret: uploadOptions.AccessKeySecret,
            stsToken: uploadOptions.SecurityToken,
            bucket: uploadOptions.Bucket
        });
        let nameID = uploadOptions.ObjectNamePrefix + nanoid() + (type ? `.${type}` : '');
        client.put(nameID, file, {headers}).then(data=>{
            resolve(data);
        }).catch((err)=> {
            reject(err);
        });
    })
}

/**
 * 文件下载
 * @param {string} link 
 * @param {string} name 
 * @returns {undefined}
 */
 file.download = async function(link, name){
     try {
         // 1. 用 fetch 下载远程文件（转为 Blob）
         const response = await fetch(link, {
             method: 'GET',
             mode: 'cors', // 允许跨域（需后端配置 CORS）
             headers: {
                 'Content-Type': 'application/octet-stream', // 二进制流类型
             },
         });
         if (!response.ok){
            return;
         };

         // 2. 转为 Blob 对象
         const blob = await response.blob();
         // 3. 生成临时 URL 并下载（逻辑同场景1）
         const url = URL.createObjectURL(blob);
         const a = document.createElement('a');
         a.href = url;
         a.download = name;
         document.body.appendChild(a);
         a.click();
         // 4. 清理资源
         document.body.removeChild(a);
         URL.revokeObjectURL(url);
     } catch (error) {
     }
}
export default file;